import React, { ComponentProps } from 'react'

export const EnvelopeIcon = (props: ComponentProps<'svg'>) => (
    <svg
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M14.5 5.73105V6.33505C14.5 6.60588 14.4267 6.87165 14.2878 7.10418C14.149 7.3367 13.9498 7.52729 13.7113 7.65572L9.39267 9.98105M1.5 5.73105V6.33505C1.49999 6.60588 1.5733 6.87165 1.71216 7.10418C1.85101 7.3367 2.05023 7.52729 2.28867 7.65572L6.60733 9.98105M6.60733 9.98105L7.28867 9.61439C7.50727 9.49663 7.7517 9.43499 8 9.43499C8.2483 9.43499 8.49273 9.49663 8.71133 9.61439L9.39333 9.98105L12.5 11.6544M6.60733 9.98105L3.5 11.6544M14.5 12.7311C14.5 13.1289 14.342 13.5104 14.0607 13.7917C13.7794 14.073 13.3978 14.2311 13 14.2311H3C2.60218 14.2311 2.22064 14.073 1.93934 13.7917C1.65804 13.5104 1.5 13.1289 1.5 12.7311V5.62705C1.49999 5.35623 1.5733 5.09045 1.71216 4.85793C1.85101 4.62541 2.05023 4.43482 2.28867 4.30639L7.28867 1.61372C7.50727 1.49597 7.7517 1.43433 8 1.43433C8.2483 1.43433 8.49273 1.49597 8.71133 1.61372L13.7113 4.30639C13.9497 4.43476 14.1488 4.62525 14.2877 4.85764C14.4265 5.09003 14.4999 5.35567 14.5 5.62639V12.7311Z"
            stroke="#333333"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
)
